import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from 'vue-router'
import store from '@/store/store'
import Login from '@/components/Login'

import ListTypes from '@/components/types/ListTypes'
import ListApiKeys from '@/components/apiKeys/ListKeys'
import ListWineries from '@/components/wineries/ListWineries'
import ListRegions from '@/components/regions/ListRegions'
import ListCastes from '@/components/castes/ListCastes'
import ListFoods from '@/components/foods/ListFoods'
import ListWines from '@/components/wines/ListWines'
import EditUser from '@/components/user/EditUser'

Vue.use(VueRouter);

export let router = new Router({
    routes: [{
        path: '/',
        name: 'empty-path',
        component: ListWines,
        meta: {
            auth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: {
            auth: false
        }
    },
    {
        path: '/types',
        name: 'types-list',
        component: ListTypes,
        meta: {
            auth: true
        }
    },
    {
        path: '/apikeys',
        name: 'apikeys-list',
        component: ListApiKeys,
        meta: {
            auth: true
        }
    },
    {
        path: '/wineries',
        name: 'wineries-list',
        component: ListWineries,
        meta: {
            auth: true
        }
    },
    {
        path: '/regions',
        name: 'regions-list',
        component: ListRegions,
        meta: {
            auth: true
        }
    },
    {
        path: '/castes',
        name: 'castes-list',
        component: ListCastes,
        meta: {
            auth: true
        }
    },
    {
        path: '/foods',
        name: 'foods-list',
        component: ListFoods,
        meta: {
            auth: true
        }
    },
    {
        path: '/wines',
        name: 'wines-list',
        component: ListWines,
        meta: {
            auth: true
        }
    },
    {
        path: '/user',
        name: 'user',
        component: EditUser,
        meta: {
            auth: true,
            menu: false
        }
    }
]
});

router.beforeEach((to, from, next) => {
    if (to.meta.auth && !store.state.isUserLoggedIn) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      if (to.meta.auth && store.state.logTime == null) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      } else {
        if (to.meta.auth && (Date.now() - store.state.logTime >= 43200000)) {
          next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          });
        } else {
          next();
        }
      }
    }
  })

export default router